import {datasource} from 'alt-utils/lib/decorators';
import {seamlessBootstrap, seamlessImmutable} from 'epic-alt-utils';
import alt from 'epic-fortnite-react/alt';
import Immutable from 'seamless-immutable';

import FeaturedIslandsActions from '../actions/FeaturedIslandsActions';
import FeaturedIslandsSource from '../sources/FeaturedIslandsSource';

const initialGetIslandsState = {
  favoriteIslandsCodes: [],
  playlistIslandsCodes: [],
  loading: false,
  error: null,
};

const initialGetIslandsForUserState = {
  userIslands: [],
  userIslandsLoading: false,
  error: null,
};

@datasource(FeaturedIslandsSource)
@seamlessImmutable
class FeaturedIslandsStore {
  constructor() {
    this.on('error', (error) => {
      console.error(error);
    });
    this.on('bootstrap', seamlessBootstrap.bind(this, null));
    this.state = Immutable({
      ...initialGetIslandsState,
      ...initialGetIslandsForUserState,
      island: {},
      addFavoriteCodeLoading: false,
      addFavoriteCodeError: null,
      addToPlayListLoading: false,
      addToPlayListError: null,
    });
    this.bindActions(FeaturedIslandsActions);
  }

  resetError() {
    this.setState(
      this.state.merge({
        error: null,
      })
    );
  }

  setIsland(island) {
    this.setState(
      this.state.merge({
        loading: false,
        island,
      })
    );
  }

  onAddFavorites(islandCode) {
    this.setState(
      this.state.merge({
        addFavoriteCodeLoading: true,
        addFavoriteCodeError: null,
      })
    );
    this.getInstance().addFavorites(islandCode);
  }

  onAddFavoritesSuccess(response) {
    const {
      data: {islandCode},
    } = response;

    this.setState(
      this.state.merge({
        addFavoriteCodeLoading: false,
        favoriteIslandsCodes: [...this.state.favoriteIslandsCodes, islandCode],
        addFavoriteCodeError: null,
      })
    );
  }

  onAddFavoritesFailure() {
    console.error('Error adding island to favourites');
    this.setState(
      this.state.merge({
        addFavoriteCodeLoading: false,
        addFavoriteCodeError: true,
      })
    );
  }

  onAddToPlaylist(islandCode) {
    this.setState(
      this.state.merge({
        addToPlaylistLoading: true,
        addToPlaylistError: null,
      })
    );
    this.getInstance().addToPlaylist(islandCode);
  }

  onAddToPlaylistSuccess(response) {
    const {
      data: {islandCode},
    } = response;

    this.setState(
      this.state.merge({
        addToPlaylistLoading: false,
        playlistIslandsCodes: [islandCode],
        addToPlaylistError: null,
      })
    );
  }
  onAddToPlaylistFailure() {
    console.error('Error adding island to playlist');
    this.setState(
      this.state.merge({
        addToPlaylistLoading: false,
        addToPlaylistError: true,
      })
    );
  }

  onCheckPlaylist(islandCode) {
    this.setState(
      this.state.merge({
        addToPlaylistLoading: true,
        addToPlaylistError: null,
      })
    );
    this.getInstance().checkPlaylist(islandCode);
  }

  onCheckPlaylistSuccess(response) {
    if (response.data && response.data.results && response.data.results.length > 0) {
      const island = response.data.results.pop();

      this.setState(
        this.state.merge({
          addToPlaylistLoading: false,
          playlistIslandsCodes: [island.linkCode],
          addToPlaylistError: null,
        })
      );
    }
  }

  onCheckPlaylistFailure() {
    console.error('Error checking island to playlist');
    this.setState(
      this.state.merge({
        checkPlaylistLoading: false,
        checkPlaylistError: true,
      })
    );
  }

  onRemoveFromPlaylist(islandCode) {
    this.setState(
      this.state.merge({
        addToPlaylistLoading: true,
        addToPlaylistError: null,
      })
    );
    this.getInstance().removeFromPlaylist(islandCode);
  }

  onRemoveFromPlaylistSuccess(response) {
    this.setState(
      this.state.merge({
        addToPlaylistLoading: false,
        playlistIslandsCodes: [],
        addToPlaylistError: null,
      })
    );
  }

  onRemovePlaylistFailure() {
    console.error('Error adding island to playlist');
    this.setState(
      this.state.merge({
        addToPlaylistLoading: false,
        addToPlaylistError: true,
      })
    );
  }

  onGetIslandsForUser(accountId) {
    if (this.state?.userIslands?.length) {
      return;
    }

    this.setState(
      this.state.merge({
        userIslandsLoading: true,
      })
    );

    this.getInstance().getIslandsForUser(accountId);
  }

  onGetIslandsForUserSuccess(response) {
    const {success} = response?.data;

    if (!success) {
      this.setState(
        this.state.merge({
          ...initialGetIslandsForUserState,
          error: true,
        })
      );
    } else {
      const {userIslands} = response?.data;
      this.setState(
        this.state.merge({
          ...initialGetIslandsForUserState,
          userIslands,
        })
      );
    }
  }

  onGetIslandsForUserFailure(error) {
    this.setState(
      this.state.merge({
        ...initialGetIslandsForUserState,
        error: true,
      })
    );
  }
}

export default alt.createStore(FeaturedIslandsStore, 'FeaturedIslandsStore');
